var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card-code',{attrs:{"title":"Answers","name":"Answers","no-body":""}},[_c('b-card-body',{},[_c('b-row',[_c('answerRepiter',{attrs:{"answers":_vm.answers}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }